import React from 'react';
import PageHero from './PageHero';
import './Divisions.css';

const Divisions = () => {
  const divisions = [
    {
      id: 1,
      title: 'Rivontrix Consulting',
      subtitle: 'Consulting Division',
      icon: 'fas fa-network-wired',
      description: 'Strategic digital transformation consulting that empowers enterprises to innovate and thrive in the digital landscape.',
      features: [
        'Cloud Migration & Architecture',
        'GenAI Strategy & Implementation',
        'Digital Strategy & Innovation',
        'Process Optimization',
        'Technology Roadmapping'
      ],
      gradient: 'linear-gradient(135deg, #667eea, #764ba2)'
    },
    {
      id: 2,
      title: 'ShieldEx',
      subtitle: 'Cybersecurity Product',
      icon: 'fas fa-shield-alt',
      description: 'An AI-powered cybersecurity exposure management platform that continously identifies, prioritizes, and reduces real-world cyber risk by understanding how attackers actually exploit your environment.',
      features: [
        'AI-Powered Threat Detection',
        'GenAI-Enhanced Security Analytics',
        'Real-time Monitoring',
        'Automated Incident Response',
        'Zero-Trust Architecture'
      ],
      gradient: 'linear-gradient(135deg, #f093fb, #f5576c)'
    },
    {
      id: 3,
      title: 'Rivontrix TechTalentPro',
      subtitle: 'Manpower Arm',
      icon: 'fas fa-users',
      description: 'Connecting enterprises with world-class AI/ML engineers, cybersecurity experts, and technology professionals.',
      features: [
        'AI/ML Engineers',
        'GenAI Specialists',
        'Cybersecurity Specialists',
        'Cloud Architects',
        'Full-Stack Developers'
      ],
      gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)'
    }
  ];

  return (
    <>
      <PageHero
        title="Our Divisions"
        subtitle="Specialized Divisions"
        description="Three specialized divisions empowering your enterprise with cutting-edge technology solutions"
        sectionId="divisions"
      />
      <section id="divisions" className="divisions">
        <div className="container">
        <div className="divisions-grid">
          {divisions.map((division, index) => (
            <div 
              key={division.id} 
              className="division-card" 
              style={{animationDelay: `${index * 0.2}s`}}
              onClick={() => {
                if (division.title === 'ShieldEx') {
                  window.scrollTo({ top: 0, behavior: 'instant' });
                  const event = new CustomEvent('sectionChange', { detail: 'shieldex' });
                  window.dispatchEvent(event);
                }
              }}
              role={division.title === 'ShieldEx' ? 'button' : undefined}
              tabIndex={division.title === 'ShieldEx' ? 0 : undefined}
              onKeyDown={(e) => {
                if (division.title === 'ShieldEx' && (e.key === 'Enter' || e.key === ' ')) {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: 'instant' });
                  const event = new CustomEvent('sectionChange', { detail: 'shieldex' });
                  window.dispatchEvent(event);
                }
              }}
              style={{
                animationDelay: `${index * 0.2}s`,
                cursor: division.title === 'ShieldEx' ? 'pointer' : 'default'
              }}
            >
              <div className="division-header">
                <div className="division-icon" style={{background: division.gradient}}>
                  <i className={division.icon}></i>
                </div>
                <div className="division-titles">
                  <h3>{division.title}</h3>
                  <p className="division-subtitle">{division.subtitle}</p>
                </div>
              </div>
              <p className="division-description">{division.description}</p>
              <div className="division-features">
                <ul>
                  {division.features.map((feature, idx) => (
                    <li key={idx}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
};

export default Divisions;

